export const getParams = (paramNames) => {
  const queryString = new URLSearchParams(window.location.search);
  const param = queryString.get(paramNames);
  return param;
};
